import Input from '../ui/Input';
import Icon from '../ui/Icon';
import SearchableSelect from '../ui/SearchableSelect';

function ProductoAplicacionForm({
  index,
  producto,
  onChange,
  onRemove,
  canRemove,
  catalogoProductos,
  catalogoStatus,
}) {
  const handleField = (field) => (event) => {
    onChange({ ...producto, [field]: event.target.value });
  };

  const handleProducto = (nombrecomercial) => {
    onChange({ ...producto, nombrecomercial });
  };

  const opciones = catalogoProductos.map((p) => p.nombre);

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <p className="font-medium text-gray-900">Producto {index + 1}</p>
        {canRemove && (
          <button
            type="button"
            onClick={onRemove}
            aria-label="Eliminar producto"
            title="Eliminar producto"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
          >
            <Icon name="trash" className="h-5 w-5" />
          </button>
        )}
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-[2fr_1fr]">
        <SearchableSelect
          id={`nombrecomercial-${index}`}
          label="Producto *"
          value={producto.nombrecomercial}
          onChange={handleProducto}
          options={opciones}
          placeholder="Seleccionar producto"
          status={catalogoStatus}
        />
        <Input
          id={`dosis-${index}`}
          label="Dosis"
          value={producto.dosis}
          onChange={handleField('dosis')}
          placeholder="Ej: 2 L/ha"
        />
      </div>
    </div>
  );
}

export default ProductoAplicacionForm;
